module.exports = __webpack_public_path__ + "media/pyrite_time.f35489b2.mp4";